import { useState, useEffect, useCallback } from "react";
import { useAuth } from "@/providers/auth-provider";
import { getIdeaBoard } from "@/services/ideas/get-idea-board";

/**
 * Hook to fetch Idea Board status (reward available/claimed).
 */
export function useIdeaBoardStatus(enabled: boolean = true) {
  const { getAccessToken } = useAuth();
  const [rewardAvailable, setRewardAvailable] = useState<boolean>(false);
  const [rewardClaimed, setRewardClaimed] = useState<boolean>(false);
  const [votesToday, setVotesToday] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchStatus = useCallback(async () => {
    const accessToken = getAccessToken();
    if (!accessToken) return;

    setIsLoading(true);
    try {
      const response = await getIdeaBoard(accessToken);
      if (response.ok && response.data) {
        setRewardAvailable(!!response.data.reward_available);
        setRewardClaimed(!!response.data.reward_claimed);
        setVotesToday(response.data.votes_today || 0);
      }
    } catch (error) {
      console.error("Failed to fetch idea board status:", error);
    } finally {
      setIsLoading(false);
    }
  }, [getAccessToken]);

  useEffect(() => {
    if (!enabled) return;
    fetchStatus();
  }, [enabled, fetchStatus]);

  return {
    rewardAvailable,
    rewardClaimed,
    votesToday,
    isLoading,
    refetch: fetchStatus,
  };
}
